(() => {
  const source = document.getElementById('aw-sitewide-media-alt-map');
  if (!source) return;

  let map;
  try {
    map = JSON.parse(source.textContent || '{}');
  } catch (_) {
    return;
  }

  const applyToImage = (image) => {
    let url;
    try {
      url = new URL(image.currentSrc || image.src, location.href);
    } catch (_) {
      return;
    }

    const filename = decodeURIComponent(url.pathname.split('/').pop() || '');
    if (!Object.prototype.hasOwnProperty.call(map, filename)) return;
    image.alt = map[filename] || '';
  };

  const apply = (root = document) => {
    if (root instanceof HTMLImageElement) applyToImage(root);
    root.querySelectorAll?.('img').forEach(applyToImage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  } else {
    apply();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) apply(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
